import {
  Typography,
  Box,
  TextField,
  Button,
  Paper,
  Container,
  Alert,
  Link,
} from '@mui/material';
import { produce } from 'immer';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import api from 'services/api';

export default function Register() {
  const [formData, setFormData] = useState({
    user_id: '',
    user_password: '',
    user_name: '',
    comp_name: '',
    industry: '',
  });
  const navigate = useNavigate();
  const [accountRegister, { isLoading, isError, error }] =
    api.endpoints.accountRegister.useMutation();

  const handleInputChange = (field) => (e) => {
    setFormData(
      produce((draft) => {
        draft[field] = e.target.value;
      }),
    );
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    for (const element of Object.keys(formData)) {
      if (!formData[element]) {
        return;
      }
    }
    accountRegister({
      user_id: formData.user_id,
      user_password: formData.user_password,
      user_name: formData.user_name,
      comp_name: formData.comp_name,
      industry: formData.industry,
    })
      .unwrap()
      .then(() => {
        navigate('/login');
      })
      .catch(() => {});
  };

  const isFormValid = () => {
    return Object.values(formData).every((value) => value.trim() !== '');
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ color: 'text.primary', mt: 4 }}>
        <Typography variant="h4" sx={{ mb: 4, textAlign: 'center' }}>
          註冊帳號
        </Typography>
        <Paper sx={{ p: 4 }}>
          <Box
            component="form"
            onSubmit={handleRegister}
            sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}
          >
            {isError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error.message}
              </Alert>
            )}
            <TextField
              label="用戶 ID"
              value={formData.user_id}
              onChange={handleInputChange('user_id')}
              required
              fullWidth
              disabled={isLoading}
              autoComplete="username"
            />
            <TextField
              label="密碼"
              type="password"
              value={formData.user_password}
              onChange={handleInputChange('user_password')}
              required
              fullWidth
              disabled={isLoading}
              autoComplete="new-password"
            />
            <TextField
              label="用戶姓名"
              value={formData.user_name}
              onChange={handleInputChange('user_name')}
              required
              fullWidth
              disabled={isLoading}
              autoComplete="name"
            />
            <TextField
              label="公司名稱"
              value={formData.comp_name}
              onChange={handleInputChange('comp_name')}
              required
              fullWidth
              disabled={isLoading}
              autoComplete="organization"
            />
            <TextField
              label="產業別"
              value={formData.industry}
              onChange={handleInputChange('industry')}
              required
              fullWidth
              disabled={isLoading}
            />
            <Button
              type="submit"
              variant="contained"
              size="large"
              disabled={!isFormValid() || isLoading}
            >
              {isLoading ? '註冊中...' : '註冊'}
            </Button>
            <Box sx={{ textAlign: 'center', mt: 2 }}>
              <Link
                component="button"
                variant="body2"
                onClick={() => navigate('/login')}
                sx={{ textDecoration: 'none' }}
              >
                已有帳號？立即登入
              </Link>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}
